module.exports = __webpack_public_path__ + "img/night-city-2.721ee72a.jpg";